<template>
	<iframe
		ref="calendar"
		class="vendasta-calendar embed"
		id="vendasta-calendar"
		v-bind:src="calendarUrl"
		title="Vendasta Calendar"
	></iframe>
</template>
<script>
import socialMarketingService from '@/services/toolbox/social-marketing-service';

export default {
	name: 'VendastaCalendar',
	components: {
		socialMarketingService,
	},
	props: [],
	data() {
		return {
			calendarDomain:
				'https://united-shore-financial-services-llc.socialsmbs.com',
			calendarUrl: '',
		};
	},
	methods: {
		startCalendar() {
			const thisRef = this;

			new Promise(function (resolve, reject) {
				resolve(socialMarketingService.getCalendarUrl());
			}).then(function (e) {
				thisRef.calendarUrl = e.data;
			});
		},
		init() {
			this.startCalendar();
		},
	},
	mounted() {
		this.init();
	},
};
</script>
<style lang="scss" scoped>
.vendasta-calendar {
	width: 100%;
	@include rem(min-height, 890px);
	border: none;
}
</style>
